export interface OrderExternalIdState {
	orderExternalId: string | null
}

export const initialOrderExternalIdState: OrderExternalIdState = {
	orderExternalId: null
}